import { useEffect, useState } from "react";
import { Select, Spin } from "antd";
import useFetchUsers from "@/utils/formatTemplate/useFetchUser";
import useDebounce from "@/utils/useDebounce";

interface TagsInputFieldProps {
  placeholder?: string;
  disabled?: boolean;
  initialTags?: string[];
  onChange?: (tags: string[]) => void;
}

export default function UserEmailTagsInputField({
  placeholder = "Enter emails",
  disabled = false,
  initialTags = [],
  onChange,
}: TagsInputFieldProps) {
  const { userOptions, fetchUsers } = useFetchUsers();
  const [tags, setTags] = useState<string[]>(initialTags);
  const [fetching, setFetching] = useState(false);
  const [searchEmail, setSearchEmail] = useState<string>("");

  const debounceValue = useDebounce(searchEmail, 500);

  useEffect(() => {
    async function fetchData() {
      if (!debounceValue) return;
      setFetching(true);
      await fetchUsers(debounceValue);
      setFetching(false);
    }

    fetchData();
  }, [debounceValue]);

  function handleSearch(search: string) {
    setSearchEmail(search);
  }

  const handleTagChange = (newTags: string[]) => {
    setTags(newTags);
    onChange?.(newTags);
  };

  return (
    <Select
      mode="multiple"
      style={{ width: "100%", textAlign: "left" }}
      placeholder={placeholder}
      value={tags}
      onSearch={handleSearch}
      onChange={handleTagChange}
      disabled={disabled}
      filterOption={false}
      notFoundContent={fetching ? <Spin size="small" /> : null}
      options={userOptions}
    />
  );
}
